import * as moment from 'moment';
import { AfterViewInit, ChangeDetectorRef, Component, HostBinding, OnInit } from '@angular/core';
import { ThemingService } from '@michelin/theme';

import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { AuthService } from '../shared/services/auth/auth.service';
import { UserLoginResponseDto } from '../shared/models/auth/auth-dto';

const darkClassName = 'dark-mode';

@Component({
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
    standalone: false
})
export class LayoutComponent implements OnInit, AfterViewInit {
  @HostBinding('class') className = this.themingService.theme.className;

  year = moment.utc().format('YYYY');
  version = environment.version;
  title = 'Cardealer';
  darkMode = this.className === darkClassName;
  userData: UserLoginResponseDto = null;
  appRouter: Router;

  constructor(
    private readonly themingService: ThemingService,
    private readonly router: Router,
    private readonly authService: AuthService,
    private readonly cdr: ChangeDetectorRef
  ) {
    this.appRouter = router;
  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  get isMichelinUser(): boolean {
    return this.userData.userProfile?.userType === 'MICHELIN';
  }

  setTheme() {
    this.darkMode = !this.darkMode;
    this.className = this.themingService.display(this.darkMode ? darkClassName : '', this.darkMode);
  }

  hasPermissions(permissions: string[]): boolean {
    return this.authService.hasPermissions(permissions);
  }

  logout() {
    this.authService.logout();
  }

  ngOnInit() {
    this.userData = this.authService.getUserData();
  }
}
